import React from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import { PowerBtn } from "../components/AllSvgs";

const Power = styled.button`
  position: fixed;
  top: 2rem;
  left: 50%;
  transform: translateX(-50%);

  background-color: #fcf6f4;
  padding: 0.3rem;
  border-radius: 50%;
  border: 1px solid #000;
  width: 2.5rem;
  height: 2.5rem;

  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: #20e3b2;
  }

  & > *:first-child {
    text-decoration: none;
    color: inherit;
  }

  @media (max-width: 40em) {
    width: 2rem;
    height: 2rem;
  }

  @media screen and (max-width: 40em) {
    svg {
      width: 20px;
      height: 20px;
    }
  }
`;
const PowerButton = () => {
  return (
    <Power>
      <NavLink to="/">
        <PowerBtn width={30} height={30} fill="currentColor"></PowerBtn>
      </NavLink>
    </Power>
  );
};

export default PowerButton;
